/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FinancementClasseSearch
 */
export interface FinancementClasseSearch {
    /**
     * 
     * @type {number}
     * @memberof FinancementClasseSearch
     */
    idClasse?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof FinancementClasseSearch
     */
    financement?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FinancementClasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FinancementClasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FinancementClasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FinancementClasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FinancementClasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FinancementClasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FinancementClasseSearch interface.
 */
export function instanceOfFinancementClasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FinancementClasseSearchFromJSON(json: any): FinancementClasseSearch {
    return FinancementClasseSearchFromJSONTyped(json, false);
}

export function FinancementClasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancementClasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasse': !exists(json, 'idClasse') ? undefined : json['idClasse'],
        'financement': !exists(json, 'financement') ? undefined : TextSearchFromJSON(json['financement']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FinancementClasseSearchToJSON(value?: FinancementClasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasse': value.idClasse,
        'financement': TextSearchToJSON(value.financement),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

